import * as React from 'react';
import closeIcon from '../../images/closeIcon.svg'


interface FileViewerProps {
    data: Array<string>,
    onClose?: (index: number) => void;
    onClick?: (index: number) => void;
}


export class FileViewer extends React.PureComponent<FileViewerProps> {

    public render() {
        return (
            <div className='file-viewer'>
                {this.props.data.map((element, index) =>
                    <div key={index} className='file-viewer__item button text-bold' onClick={() => this.props.onClick !== undefined && this.props.onClick(index)}>
                        {this.props.onClose !== undefined && <img src={closeIcon} onClick={(e) => { if (this.props.onClose !== undefined) { e.stopPropagation(); this.props.onClose(index) } }} />}
                        {element}</div>)}
            </div >
        );
    }
}